import React, { useEffect, useState } from 'react'
import { InformacionGeneralProyeccionTH } from './TypesProyecionHorasExtrasAdmin';
import { Row, Col } from "reactstrap"
import CardRegimenHE from './CardRegimenHE';
import Cargando from 'components/Varios/Cargando';
import { showAlert } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras';
import { ObtenerInformacionGeneralProyeccionesUnidades, ObtenerInformacionTablaProyeccionesUnidades } from './FunctionsProyeccionHorasExtras';
import TablaUnidadesProyeccionHE from './TablaUnidadesProyeccionHE';

import "../../../../assets/scss/Horas Extras/ProyeccionHorasExtras.scss"
import { isNullUndefinedOrEmpty } from 'functions/RequestFunctions';

export default function ProyeccionUnidades() {


    const defaultInformacionGeneral: InformacionGeneralProyeccionTH = {
        anio: 0,
        listadoRegimenLaborales: [],
        informacionProyeccion: undefined,
        listadoInformacionProyeccionUnidades: [],
        totalProyeccionUnidades: null
    }


    const [informacionGeneralProyeccionTH, setinformacionGeneralProyeccionTH] = useState<InformacionGeneralProyeccionTH>(defaultInformacionGeneral)
    const [loading, setloading] = useState<boolean>(false)

    const anioString = informacionGeneralProyeccionTH !== undefined && informacionGeneralProyeccionTH.anio !== 0 ? informacionGeneralProyeccionTH.anio.toString() : ""
    const TITULO_PANTALLA = `RESUMEN DE VALORES PROYECTADOS Y PRESUPUESTADOS DEL AÑO ${anioString}`;


    async function ObtenerInformacion() {
        setloading(true)

        const respuesta = await ObtenerInformacionGeneralProyeccionesUnidades();
        if (respuesta.status === 200 && respuesta.dataResponse) {
            setinformacionGeneralProyeccionTH(respuesta.dataResponse)
        }
        else if (respuesta.status === 204) {
            const mensajeDefault = "No existe un periodo de proyección disponible para obtener información";
            const mensajeFinal = isNullUndefinedOrEmpty(respuesta.errorMessage) ? mensajeDefault : respuesta.errorMessage ?? ""
            showAlert(mensajeFinal, false)

        }
        else if(respuesta.status === 401){
            showAlert("Su usuario no se encuentra autorizado para verificar la información", false)
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar obtener información sobre la proyección";
            const mensajeFinal = isNullUndefinedOrEmpty(respuesta.errorMessage) ? mensajeDefault : respuesta.errorMessage ?? ""
            showAlert(mensajeFinal, false)
        }
        setloading(false)
    }

    async function RefrescarTabla(idProyeccionHE: number) {
        setloading(true)
        const respuestaTabla = await ObtenerInformacionTablaProyeccionesUnidades(idProyeccionHE);

        if (respuestaTabla.status === 200 && respuestaTabla.dataResponse !== undefined) {
            setinformacionGeneralProyeccionTH((prev) => {
                if (respuestaTabla.dataResponse) {
                    return { ...prev, listadoInformacionProyeccionUnidades: respuestaTabla.dataResponse }

                }
                return { ...prev, listadoInformacionProyeccionUnidades: [] }
            })
        }
        else {
            const mensajeDefault = "Ha ocurrido un inconveniente al intentar obtener información sobre la proyección";
            showAlert(respuestaTabla.errorMessage ?? mensajeDefault, false)
        }

        setloading(false)
    }

    useEffect(() => {
        ObtenerInformacion()
    }, [])



    const contenidoCardRegimen = (
        <Row className="row-no-margin">

            {/* {informacionGeneralProyeccionTH.listadoRegimenLaborales.map((regimen, index) => (
                <Col lg ={6} xl={4} key={index} className="mb-3">
                    <CardRegimenHE
                        regimenLaboralPlan={regimen}
                        index={index}
                        totalProyeccionUnidades={informacionGeneralProyeccionTH.totalProyeccionUnidades}
                    />
                </Col>
            ))} */}

            {informacionGeneralProyeccionTH.totalProyeccionUnidades && informacionGeneralProyeccionTH.totalProyeccionUnidades.valorTotalizadoRegimen.map((regimen, index) => (
                <Col lg={6} xl={4} key={index} className="mb-3">
                    <CardRegimenHE
                        index={index}
                        regimenLaboralProyectado={regimen}
                        totalProyeccionUnidades={informacionGeneralProyeccionTH.totalProyeccionUnidades}
                    />
                </Col>
            ))}


        </Row>
    );

    return (
        <div className='content'>
            <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>
            {
                loading && <Cargando />
            }
            {
                !loading && (
                    <React.Fragment>
                        {contenidoCardRegimen}
                        <Row className="row-no-margin">

                            {
                                informacionGeneralProyeccionTH.anio > 0 && informacionGeneralProyeccionTH.listadoInformacionProyeccionUnidades.length > 0 && informacionGeneralProyeccionTH.informacionProyeccion !== undefined &&
                                (
                                    <Col xl={12}>
                                        <TablaUnidadesProyeccionHE
                                            regimendisponible={informacionGeneralProyeccionTH.listadoRegimenLaborales}
                                            selectedUnidades={informacionGeneralProyeccionTH.listadoInformacionProyeccionUnidades}
                                            anioInformacionProyeccion={informacionGeneralProyeccionTH.anio}
                                            detalleProyeccion={informacionGeneralProyeccionTH.informacionProyeccion}
                                            onActualizarTabla={() => RefrescarTabla(informacionGeneralProyeccionTH.informacionProyeccion?.idPeriodoProyeccion ?? 0)}
                                            defaultRowNumber={50}
                                            totalProyeccion={informacionGeneralProyeccionTH.totalProyeccionUnidades}
                                        />
                                    </Col>
                                )
                            }

                        </Row>
                    </React.Fragment>
                )
            }

        </div>
    )


}
